import { defineMessages } from 'react-intl';

export default defineMessages({
    caTypeOfIncident: {
        id: 'fnol.ca.views.ca-claim-type.Type of Incident',
        defaultMessage: 'Type of Incident'
    },
    caCollision: {
        id: 'fnol.ca.views.ca-claim-type.Collision',
        defaultMessage: 'Collision'
    },
    caTheft: {
        id: 'fnol.ca.views.ca-claim-type.Theft',
        defaultMessage: 'Theft / Vandalism'
    },
    caBrokenGlass: {
        id: 'fnol.ca.views.ca-claim-type.Broken Glass',
        defaultMessage: 'Glass'
    },
    caOther: {
        id: 'fnol.ca.views.ca-claim-type.Other',
        defaultMessage: 'Other'
    },
    caTypeOfCollisionOccured: {
        id: 'fnol.ca.views.ca-claim-type.What type of collision occurred?',
        defaultMessage: 'What type of collision occurred?'
    },
    recairFacility: {
        id: 'fnol.ca.views.ca-new-body-shop.What is your preferred recair facility?',
        defaultMessage: 'What is your preferred recair facility?',
    },
    recairFacilityName: {
        id: 'fnol.ca.views.ca-service-new-vendor.Repair Facility Name',
        defaultMessage: 'Repair Facility Name',
    },
    // city: {
    //     id: 'fnol.common.directives.policy-search-criteria.City',
    //     defaultMessage: 'City',
    // },
    // zipCode: {
    //     id: 'fnol.common.directives.policy-search-criteria.Zip Code',
    //     defaultMessage: 'ZIP Code',
    // },
    // chooseState: {
    //     id: 'fnol.common.directives.policy-search-criteria.Choose State.-- Choose State --',
    //     defaultMessage: '-- Choose State --'
    // },
    taxId: {
        id: 'fnol.ca.views.ca-service-new-vendor.Tax ID',
        defaultMessage: 'Tax ID',
    },
    newVendorTitle: {
        id: 'fnol.ca.views.ca-service-choice.I’ll provide repair facility details myself',
        defaultMessage: 'I’ll provide repair facility details myself'
    },
    newVendorSubTitle: {
        id: 'fnol.ca.views.ca-service-choice.Select this option if you have your own preferred repair facility.',
        defaultMessage: 'Select this option if you have your own preferred repair facility.'
    },
    headerRecair: {
        id: 'fnol.ca.views.ca-service-choice.Do you need a repair facility?',
        defaultMessage: 'Do you need a repair facility?'
    },
    choiceSubtitle: {
        id: 'fnol.ca.views.ca-service-choice.Lifetime guarantee on all parts and labour',
        defaultMessage: 'Lifetime guarantee on all parts and labour'
    },
    noRepair: {
        id: 'fnol.ca.views.ca-service-choice.I don’t need a repair facility',
        defaultMessage: 'I don’t need a repair facility'
    },
    noRepairSubTitle: {
        id: 'fnol.ca.views.ca-service-choice.Don’t worry, you can request service later from an adjuster.',
        defaultMessage: 'Don’t worry, you can request service later from an adjuster.'
    },
    recommendRepairFacility: {
        id: 'fnol.ca.views.ca-service-choice.I want to use a recommended repair facility',
        defaultMessage: 'I want to use a recommended repair facility'
    },
    recommendedFacilityYouGet: {
        id: 'fnol.ca.views.ca-service-choice.With a recommended repair facility you get',
        defaultMessage: 'With a recommended repair facility you get:'
    },
    lifetimeGuarantee: {
        id: 'fnol.ca.views.ca-service-choice.Lifetime guarantee on all parts and labour',
        defaultMessage: 'Lifetime guarantee on all parts and labour'
    },
    discountOnOtherRepairs: {
        id: 'fnol.ca.views.ca-service-choice.10% discount on other repairs',
        defaultMessage: '10% discount on other repairs'
    },
    promptRepairService: {
        id: 'fnol.ca.views.ca-service-choice.Prompt, high quality repair service',
        defaultMessage: 'Prompt, high quality repair service'
    },
    caCollisionDetails: {
        id: 'fnol.wizard.steps.ca.CollisionDetails',
        defaultMessage: 'Details'
    },
    caGlassDetails: {
        id: 'fnol.wizard.steps.ca.GlassDetails',
        defaultMessage: 'Damage'
    },
    caTheftDetails: {
        id: 'fnol.wizard.steps.ca.TheftDetails',
        defaultMessage: 'Details'
    },
    caWhatTypeOfIncident: {
        id: 'fnol.wizard.steps.ca.Type of Incident',
        defaultMessage: 'Type of Incident'
    },
    caVehicle: {
        id: 'fnol.wizard.steps.ca.Vehicles',
        defaultMessage: 'Vehicles'
    },
    caClaimAboutTheVehicle: {
        id: 'fnol.ca.directives.vehicle-incident.About the Vehicle',
        defaultMessage: 'About the Vehicle'
    },
    caClaimWhichVehicle: {
        id: 'fnol.ca.directives.vehicle-incident.Which vehicle was damaged?',
        defaultMessage: 'Which vehicle was damaged?'
    },
    caClaimChooseVehicle: {
        id: 'fnol.ca.directives.vehicle-incident.Choose Vehicle',
        defaultMessage: 'Choose Vehicle'
    },
    caClaimsWhoDriving: {
        id: 'fnol.ca.directives.vehicle-incident.Who was driving?',
        defaultMessage: 'Who was driving?'
    },
    caClaimChooseDriver: {
        id: 'fnol.ca.directives.vehicle-incident.Choose Driver',
        defaultMessage: 'Choose Driver'
    },
    caClaimYes: {
        id: 'fnol.ca.directives.vehicle-incident.Yes',
        defaultMessage: 'Yes'
    },
    caClaimNo: {
        id: 'fnol.ca.directives.vehicle-incident.No',
        defaultMessage: 'No'
    },
    caClaimDidAirbagDeploy: {
        id: 'fnol.ca.directives.vehicle-incident.Did the airbag deploy?',
        defaultMessage: 'Did the airbag deploy?'
    },
    caClaimEquipmentFailure: {
        id: 'fnol.ca.directives.vehicle-incident.Was there equipment failure?',
        defaultMessage: 'Was there equipment failure?'
    },
    caClaimWasVehicleTowed: {
        id: 'fnol.ca.directives.vehicle-incident.Was the vehicle towed?',
        defaultMessage: 'Was the vehicle towed?'
    },
    caClaimWasRentalNeeded: {
        id: 'fnol.ca.directives.vehicle-incident.Is a rental car needed?',
        defaultMessage: 'Is a rental car needed?'
    },
    caClaimPointOfImcact: {
        id: 'fnol.ca.directives.vehicle-collision.Point of Impact',
        defaultMessage: 'Point of Impact'
    },
    caClaimPassengers: {
        id: 'fnol.ca.directives.vehicle-incident.Passengers',
        defaultMessage: 'Passengers'
    },
    caClaimAddAPassenger: {
        id: 'fnol.ca.directives.vehicle-incident.Add a Passenger',
        defaultMessage: 'Add a Passenger'
    },
    caClaimAnotherPerson: {
        id: 'fnol.ca.directives.vehicle-incident.Another person',
        defaultMessage: 'Another person'
    },
    caClaimAddVehicle: {
        id: 'fnol.ca.directives.vehicle-incident.Add Another Vehicle',
        defaultMessage: 'Add Another Vehicle'
    },
    caClaimcassengerFirstName: {
        id: 'fnol.ca.directives.vehicle-incident.First name',
        defaultMessage: 'First name'
    },
    caClaimPassengerLastName: {
        id: 'fnol.ca.directives.vehicle-incident.Last name',
        defaultMessage: 'Last name'
    },
    caClaimPassengerPhoneNumber: {
        id: 'fnol.ca.directives.vehicle-incident.Phone number',
        defaultMessage: 'Phone number (optional)'
    },
    caClaimPassengerEdit: {
        id: 'fnol.ca.directives.vehicle-incident.Remove',
        defaultMessage: 'Remove'
    },
    caClaimPassengerDelete: {
        id: 'fnol.ca.directives.vehicle-incident.Delete',
        defaultMessage: 'Delete'
    },
    wizardPARepair: {
        id: 'fnol.wizard.steps.ca.Repair',
        defaultMessage: 'Repair'
    },
    wizardPARepairFacility: {
        id: 'fnol.wizard.steps.ca.Repair Facility',
        defaultMessage: 'Repair Facility'
    },
    caVehicleOtherDriver: {
        id: 'fnol.ca.directives.vehicle-incident.Other Driver',
        defaultMessage: 'Other Driver'
    },
    caVehicleOtherVehicle: {
        id: 'fnol.ca.directives.vehicle-incident.Other Vehicle',
        defaultMessage: 'Other Vehicle'
    },
    caVehicleNewVehicle: {
        id: 'fnol.ca.directives.vehicle-incident.New Vehicle',
        defaultMessage: 'New Vehicle'
    },
    caVehicleColor: {
        id: 'fnol.ca.directives.add-new-vehicle.Vehicle Color',
        defaultMessage: 'Vehicle Color'
    },
    caVehicleLicensePlate: {
        id: 'fnol.ca.directives.add-new-vehicle.License Plate',
        defaultMessage: 'License Plate Number'
    },
    caVehicleMake: {
        id: 'fnol.ca.directives.add-new-vehicle.Make',
        defaultMessage: 'Make'
    },
    caVehicleManufacturer: {
        id: 'fnol.ca.directives.add-new-vehicle.Choose Vehicle Manufacturer',
        defaultMessage: 'Choose Vehicle Manufacturer'
    },
    caVehicleModel: {
        id: 'fnol.ca.directives.add-new-vehicle.Model',
        defaultMessage: 'Model'
    },
    caVehicleState: {
        id: 'fnol.ca.directives.add-new-vehicle.State',
        defaultMessage: 'State'
    },
    caVehicleChooseState: {
        id: 'fnol.ca.directives.add-new-vehicle.Choose Vehicle State',
        defaultMessage: 'Choose Vehicle State'
    },
    caVehicleVIN: {
        id: 'fnol.ca.directives.add-new-vehicle.VIN',
        defaultMessage: 'VIN'
    },
    caVehicleYear: {
        id: 'fnol.ca.directives.add-new-vehicle.Year',
        defaultMessage: 'Year'
    },
    caVehicleChooseYear: {
        id: 'fnol.ca.directives.add-new-vehicle.Choose Vehicle Year',
        defaultMessage: 'Choose Vehicle Year'
    },
    caVehicleDriverFirstName: {
        id: 'fnol.ca.directives.add-new-driver.First Name',
        defaultMessage: 'First Name'
    },
    caVehicleDriverLastName: {
        id: 'fnol.ca.directives.add-new-driver.Last Name',
        defaultMessage: 'Last Name'
    },
    caVehicleDriverHomePhone: {
        id: 'fnol.ca.directives.add-new-driver.Home Phone',
        defaultMessage: 'Home Phone'
    },
    caVehicleDriverMobilePhone: {
        id: 'fnol.ca.directives.add-new-driver.Mobile Phone',
        defaultMessage: 'Mobile Phone'
    },
    caVehicleValidPhoneNumber: {
        id: 'fnol.ca.directives.add-new-driver.Value must be a valid phone number',
        defaultMessage: 'Value must be a valid phone number'
    },
    caCreateDraftClaim: {
        id: 'fnol.ca.config.FlowConfig.Creating personal auto draft claim...',
        defaultMessage: 'Creating personal auto draft claim...'
    },
    caCreateDraftErrorTitle: {
        id: 'fnol.ca.config.FlowConfig.Error creating claim',
        defaultMessage: 'Error creating claim'
    },
    caCreateDraftErrorMessage: {
        id: 'fnol.ca.config.FlowConfig.An error occurred attempting to create claim.',
        defaultMessage: 'An error occurred attempting to create claim.'
    },
    caVehicleNewDriver: {
        id: 'fnol.ca.directives.vehicle-incident.New Driver',
        defaultMessage: 'New Driver'
    },
    caRepairChoiceVehicleDamaged: {
        id: 'fnol.ca.views.ca-repair-choice.Which vehicle you want to repair?',
        defaultMessage: 'Which vehicle you want to repair?'
    },
    caRepairChoiceChooseVehicle: {
        id: 'fnol.ca.views.ca-repair-choice.Choose Vehicle',
        defaultMessage: 'Choose Vehicle'
    },
    optional: {
        id: 'fnol.ca.directives.add-new-driver.optional',
        defaultMessage: 'optional'
    },
    caLossCauseType: {
        id: 'fnol.ca.views.ca-claim-type.Loss Cause',
        defaultMessage: 'Loss Cause:'
    },
    caComprehensive: {
        id: 'fnol.ca.views.ca-claim-type.Comprehensive',
        defaultMessage: 'Comprehensive'
    },
    caWindsheild: {
        id: 'fnol.ca.views.ca-claim-type.Windsheild',
        defaultMessage: 'Windshield'
    },
    caClaimVehicleSafeToDrive: {
        id: 'fnol.ca.directives.vehicle-incident.Was there a driver involved?',
        defaultMessage: 'Was there a driver involved?'
    },
    caClaimVehicleParked: {
        id: 'fnol.ca.directives.vehicle-incident.Was the vehicle parked?',
        defaultMessage: 'Was the vehicle parked?'
    },
    caIncidentDetails: {
        id: 'fnol.ca.views.ca-claim-type.Incident Details',
        defaultMessage: 'Incident Details'
    },
    caClaimVehicleDamageDesc: {
        id: 'fnol.ca.directives.vehicle-incident.Damage Description',
        defaultMessage: 'Damage Description'
    },
    caNonCollisionTypes: {
        id: 'fnol.pa.views.pa-claim-type.Non-Collision (theft, vandalism, hail, etc)',
        defaultMessage: 'Non-Collision (theft, vandalism, hail, etc)'
    },
    caVehicleIncidentDetails: {
        id: 'fnol.ca.views.ca-claim-type.Vehicle Incident Details',
        defaultMessage: 'Vehicle Incident Details'
    },
    caVehiclesDamageDetails: {
        id: 'fnol.wizard.steps.ca.Vehicles Damage Details',
        defaultMessage: 'Vehicles Damage Details'
    },
    caSelectVehicles: {
        id: 'fnol.ca.views.ca-fleet.Select Involved Policy Vehicle',
        defaultMessage: 'Select Involved Policy Vehicle'
    },
    describeNotListedVehicle: {
        id: 'fnol.ca.views.ca-fleet.If your vehicle is not listed, please describe your vehicle (year, make, model)',
        defaultMessage: 'If your vehicle is not listed, please describe your vehicle (year, make, model)'
    }
});
